(function() {
  function addAccountAdminFooterEntry() {
    if (document.querySelector('.origin-account-admin-footer-entry')) return;
    const copyright = document.querySelector('.footer__copyright');
    if (!copyright) return;

    const entry = document.createElement('small');
    entry.className = 'copyright__content origin-account-admin-footer-entry';
    entry.style.marginLeft = '1.6rem';

    const link = document.createElement('a');
    link.href = '/pages/account-admin';
    link.textContent = 'Account Admin';
    link.setAttribute('aria-label', 'Origin Pro Account Admin login');

    entry.appendChild(link);
    copyright.appendChild(entry);
  }

  function loadAccountAdminTaxModule() {
    const root = document.querySelector('[data-origin-account-admin]');
    if (!root || root.dataset.authorized !== 'true') return;
    if (document.querySelector('script[data-origin-account-admin-tax-module]')) return;

    const script = document.createElement('script');
    script.src = '/apps/origin-account-admin?action=tax-ui-js';
    script.defer = true;
    script.dataset.originAccountAdminTaxModule = '';
    document.head.appendChild(script);
  }

  function boot() {
    addAccountAdminFooterEntry();
    loadAccountAdminTaxModule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
